import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { buildBackendUrl, isBackendPath } from '@gs/shared';
import { ENVIRONMENT as environment } from '@gs/shared/template/environment';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';

/**
 * Matches the CS3 backend paths (`/admin`, `/authorize`, their subpaths and culture variants).
 * A matcher instead of a plain path because `path: 'admin'` never matches `/de-de/admin`.
 * @param segments the url segments of the current navigation
 * @returns the consumed segments on a match, otherwise null
 */
const backendPathMatcher = (segments: UrlSegment[]): UrlMatchResult | null =>
  isBackendPath(`/${segments.map((segment) => segment.path).join('/')}`) ? { consumed: segments } : null;

export const routes: Routes = [
  {
    // CS4-2579: fallback for navigations that bypass the SSR redirect in server.ts (e.g. `nx serve`).
    matcher: backendPathMatcher,
    canActivate: [
      () => {
        const platformId = inject(PLATFORM_ID);
        if (isPlatformBrowser(platformId)) {
          const target = buildBackendUrl(window.location.pathname + window.location.search, environment.BACKEND_URL);
          if (target) window.location.href = target;
        }
        return false;
      }
    ],
    children: []
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: '**',
        loadChildren: () => import('./pages/home/home.routes').then((m) => m.routes)
      }
    ]
  }
];
